import { render, staticRenderFns } from "./OrderFulfillmentStats.vue?vue&type=template&id=03895d52"
import script from "./OrderFulfillmentStats.vue?vue&type=script&lang=js"
export * from "./OrderFulfillmentStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports